import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { PersonaBuscador, PersonaBuscadorFoto } from "src/common/buscador-personas";
import { buscadorPersonaFotoCancelled, buscadorPersonaFotoDoNothing, buscadorPersonaFotoLoaded, buscadorPersonaFotoRequested, buscadorPersonaPageCancelled, buscadorPersonaPageLoaded, buscadorPersonaPageRequested, buscadorPersonaToggleCollapse, buscadorResultadosClear } from "./buscador-personas.actions";
import { CollapseMap } from "src/app/mi-perfil/common/comprobante-tesoreria";

export interface BuscadorPersonasState extends EntityState<PersonaBuscador> {
	ready: boolean;
	total: number;
	personasFoto: PersonaBuscadorFoto;
	nextPageNum: number;
	pageSize: number;
	morePagesToLoad: boolean;
	cleared: boolean;
	collapse: CollapseMap;
	inputText: string;
}

export const buscadorPersonasAdapter: EntityAdapter<PersonaBuscador> = createEntityAdapter<PersonaBuscador>({
	selectId: ( persona: PersonaBuscador ) => persona.idPersona
});

const initialBuscadorPersonasState: BuscadorPersonasState = buscadorPersonasAdapter.getInitialState({
	ready: true,
	total: null,
	personasFoto: null,
	nextPageNum: 0,
	pageSize: 10,
	morePagesToLoad: false,
	cleared: false,
	collapse: null,
	inputText: null
});

export const buscadorPersonasReducer = createReducer(
	initialBuscadorPersonasState,

	on( buscadorPersonaPageRequested, ( state, { text } ) => {
		return {
			...state,
			ready: false,
			cleared: false,
			inputText: text
		};
	}),
	on( buscadorPersonaPageLoaded, ( state, { cleared, nextPageNum, buscadorData } ) => {
		let total: number = buscadorData.total;
		let personas: PersonaBuscador[] = buscadorData.personas;

		if( cleared )
			state = buscadorPersonasAdapter.removeAll( state );

		let collapse: CollapseMap = state.collapse? { ...state.collapse }: {};
		if( personas && personas.length > 0 ) {
			personas.map( persona => collapse[ persona.idPersona ] = true );
		}

		return buscadorPersonasAdapter.addMany( personas, {
			...state,
			total,
			ready: true,
			nextPageNum,
			cleared,
			morePagesToLoad: total - state.ids.length - personas.length > 0,
			collapse
		});
	}),
	on( buscadorPersonaPageCancelled, ( state ) => ({ ...state, ready: true }) ),
	on( buscadorResultadosClear, ( state ) => buscadorPersonasAdapter.removeAll({
		...state,
		total: null,
		nextPageNum: 0,
		morePagesToLoad: false,
		cleared: false,
		collapse: null,
		personasFoto: null,
		inputText: null
	})),

	// Foto related actions
	on( buscadorPersonaFotoRequested, ( state, { idUsuarioMf } ) => ({ ...state, personasFoto: { ...state.personasFoto, [idUsuarioMf]: { foto: null, found: null } }} )),
	on( buscadorPersonaFotoLoaded, ( state, { idUsuarioMf, foto } ) => ({ ...state, personasFoto: { ...state.personasFoto, [idUsuarioMf]: { foto, found: true } }} )),
	on( buscadorPersonaFotoCancelled, ( state, { idUsuarioMf } ) => ({ ...state, personasFoto: { ...state.personasFoto, [idUsuarioMf]: { foto: null, found: false } }} )),
	on( buscadorPersonaFotoDoNothing, ( state ) => state ),
	// Toggle Collapse
	on( buscadorPersonaToggleCollapse, ( state, { idPersona } ) => {
		let collapse: CollapseMap = { ...state.collapse };
		collapse[ idPersona ] = !collapse[ idPersona ];
		return { ...state, collapse };
	}),
);

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = buscadorPersonasAdapter.getSelectors();